var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _g2, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _g3, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCampaignEmptyState(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 377,
    viewBox: "0 0 360 377",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M179.357 270.089C250.794 270.089 308.708 212.174 308.708 140.482C308.708 68.7907 250.538 10.8761 179.357 10.8761C107.921 10.8761 50.0059 68.7907 50.0059 140.482C50.0059 212.174 107.921 270.089 179.357 270.089Z",
    fill: "#F3F1FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M300.288 55.5241C306.066 55.5241 310.749 50.8408 310.749 45.0637C310.749 39.2867 306.066 34.6034 300.288 34.6034C294.511 34.6034 289.828 39.2867 289.828 45.0637C289.828 50.8408 294.511 55.5241 300.288 55.5241Z",
    fill: "#C8B5F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M315.597 14.7031C319.542 14.7031 322.74 11.5048 322.74 7.55943C322.74 3.61409 319.542 0.415771 315.597 0.415771C311.651 0.415771 308.453 3.61409 308.453 7.55943C308.453 11.5048 311.651 14.7031 315.597 14.7031Z",
    fill: "#C8B5F8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8937 55.2689C60.839 55.2689 64.0373 52.0706 64.0373 48.1252C64.0373 44.1799 60.839 40.9816 56.8937 40.9816C52.9483 40.9816 49.75 44.1799 49.75 48.1252C49.75 52.0706 52.9483 55.2689 56.8937 55.2689Z",
    fill: "#C8B5F8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2668 193.039C20.5938 193.039 26.5336 187.1 26.5336 179.773C26.5336 172.445 20.5938 166.506 13.2668 166.506C5.93974 166.506 0 172.445 0 179.773C0 187.1 5.93974 193.039 13.2668 193.039Z",
    fill: "#C8B5F8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_4619)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.798 51.3012L274.363 157.606C277.738 161.312 277.494 166.908 273.788 170.283L168.79 266.287C165.083 269.662 159.487 269.419 156.113 265.713L29.7336 127.36C26.3586 123.654 26.6019 118.058 30.3079 114.683L106.336 45.3239L174.798 51.3012Z",
    fill: "url(#paint0_linear_0_4619)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M214.094 130.943L157.382 182.729L151.09 188.317L132.226 205.655C131.439 206.353 131.352 207.838 132.395 208.733C133.211 209.745 134.696 209.833 135.483 209.135L154.347 191.797L160.639 186.208L217.35 134.423C218.137 133.724 218.225 132.239 217.182 131.345C216.365 130.332 214.88 130.244 214.094 130.943Z",
    fill: "#D5DDEA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M201.765 117.81L180.649 136.899L173.463 143.53L120.35 192.285C119.563 192.984 119.475 194.469 120.518 195.363C121.335 196.376 122.82 196.464 123.606 195.765L176.946 146.892L184.132 140.26L205.248 121.172C206.034 120.473 206.122 118.988 205.079 118.093C204.155 117.425 202.551 117.111 201.765 117.81Z",
    fill: "#D5DDEA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M189.997 104.096L184.492 108.986L178.987 113.877L107.903 178.926C107.116 179.624 107.029 181.109 108.072 182.004C108.888 183.016 110.373 183.104 111.16 182.406L182.243 117.357L188.309 111.886L193.136 107.35C193.922 106.651 194.01 105.166 192.967 104.272C192.268 103.485 191.009 103.279 189.997 104.096Z",
    fill: "#D5DDEA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M193.593 204.112L189.661 207.605C188.875 208.303 187.389 208.216 186.573 207.203C185.756 206.19 185.618 204.823 186.404 204.125L190.336 200.632C191.123 199.933 192.608 200.021 193.425 201.034C194.359 202.272 194.38 203.413 193.593 204.112Z",
    fill: "#CED7E2"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M181.689 214.935L159.226 235.303C158.44 236.002 156.955 235.914 156.138 234.901C155.321 233.889 155.183 232.522 155.969 231.823L178.432 211.455C179.218 210.757 180.703 210.845 181.52 211.857C182.563 212.752 182.701 214.119 181.689 214.935Z",
    fill: "#D5DDEA"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M178.68 90.146L160.937 106.322L156.67 110.278L96.0263 165.556C95.2398 166.255 95.152 167.74 96.1949 168.634C97.0116 169.647 98.4967 169.735 99.2831 169.036L159.819 114.102L164.085 110.146L181.603 94.0883C182.616 93.2716 182.477 91.9046 181.543 90.6659C181.07 89.7613 179.467 89.4474 178.68 90.146Z",
    fill: "#D5DDEA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M112.224 81.3943L61.9123 127.247C60.7917 128.408 58.9624 128.212 57.8014 127.091C56.6404 125.971 56.8362 124.141 57.9569 122.98L108.269 77.128C109.39 75.967 111.219 76.1628 112.38 77.2834C113.541 78.404 113.345 80.2333 112.224 81.3943Z",
    fill: "#D5DDEA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M92.397 121.686L73.0802 139.259C71.9596 140.42 70.1303 140.224 68.9693 139.104C67.8083 137.983 68.0041 136.154 69.1248 134.993L88.2154 117.538C89.336 116.377 91.1653 116.572 92.3263 117.693C93.4873 118.814 93.2915 120.643 92.397 121.686Z",
    fill: "#D5DDEA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M106.336 45.324L133.336 74.9725C137.173 79.0128 143.91 79.2359 147.95 75.3985L174.797 51.3013",
    fill: "#D5DDEA"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_0_4619)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.742 155.79L284.975 296.332C286.223 301.187 283.389 306.018 278.534 307.266L140.813 342.964C135.958 344.212 131.127 341.378 129.879 336.524L82.9491 155.11C81.7012 150.256 84.5352 145.424 89.3899 144.176L189.039 118.466L246.742 155.79Z",
    fill: "url(#paint1_linear_0_4619)"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M244.194 244.562L169.84 263.783L161.665 265.778L136.88 272.27C135.858 272.519 135.085 273.79 135.588 275.069C135.836 276.346 137.107 277.119 138.129 276.869L162.914 270.377L171.09 268.383L245.444 249.162C246.466 248.913 247.238 247.641 246.735 246.363C246.488 245.086 245.216 244.313 244.194 244.562Z",
    fill: "#D5DDEA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M239.446 227.186L211.851 234.172L202.397 236.67L132.641 254.896C131.619 255.146 130.847 256.417 131.35 257.696C131.598 258.973 132.869 259.745 133.891 259.496L203.902 241.271L213.356 238.773L240.95 231.787C241.972 231.538 242.745 230.267 242.242 228.988C241.738 227.965 240.468 226.937 239.446 227.186Z",
    fill: "#D5DDEA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M235.464 209.559L228.31 211.304L221.157 213.049L127.894 237.265C126.872 237.514 126.1 238.785 126.603 240.064C126.85 241.341 128.122 242.114 129.144 241.864L222.406 217.649L230.327 215.653L236.715 213.903C237.737 213.654 238.51 212.383 238.007 211.104C237.757 210.082 236.741 209.311 235.464 209.559Z",
    fill: "#D5DDEA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M191.832 299.628L186.722 300.874C185.7 301.123 184.429 300.351 184.181 299.074C183.933 297.797 184.451 296.524 185.473 296.275L190.583 295.028C191.605 294.779 192.876 295.551 193.124 296.829C193.37 298.361 192.854 299.378 191.832 299.628Z",
    fill: "#CED7E2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M176.246 303.621L146.863 311.107C145.841 311.357 144.569 310.584 144.321 309.307C144.074 308.03 144.591 306.757 145.613 306.508L174.996 299.021C176.018 298.772 177.29 299.545 177.537 300.822C178.04 302.1 177.523 303.373 176.246 303.621Z",
    fill: "#D5DDEA"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M231.993 191.935L208.742 197.925L203.12 199.424L123.657 219.892C122.635 220.141 121.862 221.412 122.365 222.691C122.613 223.968 123.884 224.741 124.906 224.491L204.113 204.277L209.735 202.779L232.731 196.787C234.008 196.539 234.526 195.266 234.279 193.734C234.285 192.713 233.015 191.686 231.993 191.935Z",
    fill: "#D5DDEA"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M177.361 153.098L111.439 170.071C109.905 170.572 108.38 169.543 107.879 168.009C107.377 166.476 108.406 164.951 109.94 164.449L175.862 147.476C177.395 146.975 178.92 148.004 179.422 149.538C179.923 151.071 178.894 152.596 177.361 153.098Z",
    fill: "#D5DDEA"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M140.981 179.424L115.686 185.913C114.152 186.415 112.627 185.385 112.125 183.852C111.624 182.318 112.653 180.793 114.187 180.292L139.227 173.801C140.761 173.3 142.286 174.329 142.787 175.862C143.289 177.396 142.26 178.921 140.981 179.424Z",
    fill: "#D5DDEA"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M189.039 118.466L199.023 157.304C200.523 162.67 206.372 166.02 211.738 164.52L246.742 155.79",
    fill: "#D5DDEA"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_0_4619)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.357 153.91L244.134 273.619C241.353 277.662 235.55 278.565 231.616 275.554L116.03 193.17C111.987 190.389 111.084 184.585 113.865 180.542L222.637 28.0823C225.417 24.0386 231.221 23.1363 235.155 26.1473L319.072 86.0447L327.357 153.91Z",
    fill: "url(#paint2_linear_0_4619)"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M257.704 209.129L195.287 164.596L188.581 159.695L167.662 144.891C166.851 144.22 165.26 144.591 164.71 145.742C163.93 146.783 164.07 148.264 164.881 148.934L185.8 163.739L192.506 168.64L254.923 213.173C255.734 213.843 257.325 213.473 257.875 212.322C258.656 211.281 258.745 209.91 257.704 209.129Z",
    fill: "#CED7E2"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M268.058 194.566L244.827 178.091L237.08 172.409L178.246 130.437C177.435 129.767 175.844 130.138 175.294 131.289C174.514 132.33 174.654 133.811 175.465 134.481L234.299 176.453L242.046 182.135L265.277 198.61C266.088 199.28 267.679 198.909 268.229 197.758C269.009 196.717 268.869 195.236 268.058 194.566Z",
    fill: "#CED7E2"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M278.981 179.993L272.855 175.651L266.73 171.31L188.248 115.424C187.437 114.754 185.846 115.124 185.296 116.275C184.516 117.316 184.656 118.797 185.467 119.468L263.949 175.354L270.655 180.255L275.97 183.926C276.781 184.596 278.372 184.226 278.922 183.075C279.932 182.144 280.022 180.773 278.981 179.993Z",
    fill: "#D5DDEA"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M181.85 204.549L177.576 201.658C176.766 200.987 176.625 199.506 177.405 198.466C178.186 197.425 179.546 196.944 180.357 197.614L184.631 200.505C185.442 201.175 185.582 202.656 184.802 203.697C183.912 204.968 182.771 204.989 181.85 204.549Z",
    fill: "#CED7E2"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M169.018 195.306L144.285 177.831C143.475 177.161 143.334 175.68 144.114 174.639C144.895 173.598 146.255 173.117 147.066 173.787L171.799 191.262C172.61 191.932 172.75 193.413 171.97 194.454C171.08 195.726 169.829 195.976 169.018 195.306Z",
    fill: "#E3EAF2"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M290.145 166.1L270.497 152.186L265.643 148.735L198.832 100.971C198.021 100.3 196.43 100.671 195.88 101.822C195.1 102.863 195.24 104.344 196.051 105.014L262.862 152.778L267.717 156.229L287.134 170.033C288.175 170.813 289.536 170.333 290.316 169.292C291.097 168.251 290.956 166.77 290.145 166.1Z",
    fill: "#D5DDEA"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M284.961 99.4342L229.48 59.9127C228.209 59.0225 227.949 57.2013 228.839 55.9301C229.729 54.659 231.55 54.3983 232.821 55.2885L288.302 94.81C289.573 95.7002 289.834 97.5214 288.944 98.7926C288.164 99.8335 286.232 100.324 284.961 99.4342Z",
    fill: "#D5DDEA"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M241.397 88.2291L220.128 72.9746C218.857 72.0844 218.596 70.2632 219.486 68.992C220.377 67.7209 222.198 67.4601 223.469 68.3504L244.508 83.4948C245.779 84.3851 246.04 86.2063 245.15 87.4775C244.26 88.7486 242.438 89.0093 241.397 88.2291Z",
    fill: "#D5DDEA"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M318.841 85.9346L295.574 118.644C292.233 123.269 293.606 129.863 298.231 133.204L327.357 153.91",
    fill: "#D5DDEA"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M176.582 159.253C183.975 159.253 189.969 153.253 189.969 145.851C189.969 138.449 183.975 132.448 176.582 132.448C169.188 132.448 163.194 138.449 163.194 145.851C163.194 153.253 169.188 159.253 176.582 159.253Z",
    fill: "#15112D"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M142.09 146.902L139.098 140.543C138.835 139.912 138.573 139.281 138.258 138.703C134.845 132.343 128.125 127.981 120.408 127.981C113.268 127.981 107.021 131.66 103.398 137.284L97.5186 145.168L100.301 145.904C100.196 146.692 100.143 147.533 100.143 148.321C100.143 159.516 109.226 168.609 120.408 168.609C131.59 168.609 140.673 159.516 140.673 148.321C140.673 147.953 140.673 147.585 140.62 147.218L142.09 146.902Z",
    fill: "#15112D"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M211.073 146.902L214.066 140.595C214.328 139.964 214.591 139.334 214.906 138.756C218.318 132.396 225.038 128.034 232.755 128.034C239.895 128.034 246.142 131.713 249.765 137.336L255.645 145.168L252.862 145.903C252.967 146.692 253.02 147.533 253.02 148.321C253.02 159.516 243.938 168.609 232.755 168.609C221.573 168.609 212.491 159.516 212.491 148.321C212.491 147.953 212.491 147.585 212.543 147.217L211.073 146.902Z",
    fill: "#15112D"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M286.829 213.546C286.829 221.273 284.414 215.281 284.414 215.281L266.249 187.635L212.333 203.508L201.36 206.714L176.634 182.116L151.907 206.714L87.018 187.635L68.8534 215.281C68.8534 215.281 66.4385 221.22 66.4385 213.546C66.4385 195.782 79.1957 170.343 90.5879 151.37C95.6803 142.855 105.235 138.283 114.895 137.547C121.825 137.021 129.7 138.125 135.632 141.909C136.892 142.698 139.307 145.115 140.934 144.852C149.807 143.486 159.151 141.489 166.081 139.912C173.169 138.283 180.518 138.283 187.553 139.964C194.378 141.541 203.513 143.538 212.333 144.905C213.96 145.168 216.375 142.803 217.635 141.962C223.567 138.125 231.442 137.021 238.372 137.599C248.032 138.335 257.587 142.855 262.679 151.422C274.071 170.396 286.829 195.782 286.829 213.546Z",
    fill: "#7647EE"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M249.817 179.173L212.28 203.56L201.308 206.766L176.581 182.169V156.52C186.188 156.52 202.2 163.616 208.553 169.923C217.268 162.722 230.392 155.627 249.817 159.253C269.241 162.827 249.817 179.173 249.817 179.173Z",
    fill: "url(#paint3_linear_0_4619)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M103.346 179.173L140.883 203.56L151.855 206.766L176.582 182.169V156.52C166.975 156.52 150.962 163.616 144.61 169.923C135.895 162.722 122.771 155.627 103.346 159.253C83.9215 162.827 103.346 179.173 103.346 179.173Z",
    fill: "url(#paint4_linear_0_4619)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M176.582 188.476C183.975 188.476 189.969 182.476 189.969 175.074C189.969 167.672 183.975 161.671 176.582 161.671C169.188 161.671 163.194 167.672 163.194 175.074C163.194 182.476 169.188 188.476 176.582 188.476Z",
    fill: "#15112D"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M111.168 262.268C135.929 262.268 156.002 242.173 156.002 217.383C156.002 192.594 135.929 172.498 111.168 172.498C86.4069 172.498 66.334 192.594 66.334 217.383C66.334 242.173 86.4069 262.268 111.168 262.268Z",
    fill: "#C8B5F8"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M111.168 250.863C129.638 250.863 144.61 235.874 144.61 217.383C144.61 198.893 129.638 183.903 111.168 183.903C92.6989 183.903 77.7266 198.893 77.7266 217.383C77.7266 235.874 92.6989 250.863 111.168 250.863Z",
    fill: "#15112D"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M111.168 238.144C126.129 238.144 138.257 226.002 138.257 211.024C138.257 196.045 126.129 183.903 111.168 183.903C96.2065 183.903 84.0781 196.045 84.0781 211.024C84.0781 226.002 96.2065 238.144 111.168 238.144Z",
    fill: "#DDDDDD"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M93.3187 213.126C92.1637 213.126 91.2188 212.18 91.2188 211.024C91.2188 199.986 100.196 191.051 111.168 191.051C112.323 191.051 113.268 191.997 113.268 193.154C113.268 194.31 112.323 195.256 111.168 195.256C102.453 195.256 95.4187 202.351 95.4187 211.024C95.4187 212.18 94.4737 213.126 93.3187 213.126Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M241.995 262.268C266.756 262.268 286.829 242.173 286.829 217.383C286.829 192.594 266.756 172.498 241.995 172.498C217.234 172.498 197.161 192.594 197.161 217.383C197.161 242.173 217.234 262.268 241.995 262.268Z",
    fill: "#C8B5F8"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M241.994 250.863C260.464 250.863 275.436 235.874 275.436 217.383C275.436 198.893 260.464 183.903 241.994 183.903C223.525 183.903 208.553 198.893 208.553 217.383C208.553 235.874 223.525 250.863 241.994 250.863Z",
    fill: "#15112D"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M241.995 238.144C256.956 238.144 269.084 226.002 269.084 211.024C269.084 196.045 256.956 183.903 241.995 183.903C227.034 183.903 214.905 196.045 214.905 211.024C214.905 226.002 227.034 238.144 241.995 238.144Z",
    fill: "#DDDDDD"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M243.15 193.154C243.15 191.997 242.205 191.051 241.05 191.051C230.025 191.051 221.101 200.039 221.101 211.024C221.101 212.18 222.046 213.126 223.201 213.126C224.356 213.126 225.3 212.18 225.3 211.024C225.3 202.299 232.388 195.256 241.05 195.256C242.205 195.256 243.15 194.31 243.15 193.154Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_4619",
    x: 5.35645,
    y: 34.3239,
    width: 293.383,
    height: 267.341,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_4619"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_4619",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_0_4619",
    x: 60.6553,
    y: 107.466,
    width: 246.614,
    height: 268.792,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_4619"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_4619",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_0_4619",
    x: 90.2598,
    y: 13.363,
    width: 259.098,
    height: 296.975,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_4619"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_4619",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_4619",
    x1: 99.9098,
    y1: 42.807,
    x2: 207.649,
    y2: 249.074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_4619",
    x1: 184.538,
    y1: 113.234,
    x2: 183.21,
    y2: 345.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_4619",
    x1: 280.441,
    y1: 41.7671,
    x2: 179.275,
    y2: 253.457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_4619",
    x1: 241.473,
    y1: 172.957,
    x2: 180.443,
    y2: 185.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00289017,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_0_4619",
    x1: 102.185,
    y1: 172.957,
    x2: 172.845,
    y2: 162.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00289017,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignEmptyState);
export default __webpack_public_path__ + "static/media/campaign-empty-state.6030d1a07c5fbb0e800dca5112b2adf2.svg";
export { ForwardRef as ReactComponent };